module.exports = __webpack_public_path__ + "static/img/advantage03.0e307c4.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/advantage03.png
// module id = KZwV
// module chunks = 1